// extracted by mini-css-extract-plugin
export default {"root":"Checkbox_root__MKLeb","disabled":"Checkbox_disabled__oFHtL","hidden":"Checkbox_hidden__9GOin","checkbox":"Checkbox_checkbox__wDtk1"};